/**
 * Skins are purely cosmetic: a color (the "cosmetic parameter on a circle")
 * plus catalog metadata. Free skins are owned by everyone; premium skins are
 * gated through the billing entitlement. This catalog is data only — add or
 * remove entries freely.
 */
export interface Skin {
  id: string;
  name: string;
  color: string;
  /** Premium skins require a billing entitlement to use. */
  premium: boolean;
}

export const DEFAULT_SKIN_ID = 'sky';

export const SKIN_CATALOG: Skin[] = [
  { id: 'sky', name: 'Sky', color: '#38bdf8', premium: false },
  { id: 'lime', name: 'Lime', color: '#a3e635', premium: false },
  { id: 'rose', name: 'Rose', color: '#f472b6', premium: false },
  { id: 'amber', name: 'Amber', color: '#fbbf24', premium: true },
  { id: 'violet', name: 'Violet', color: '#a78bfa', premium: true },
  { id: 'crimson', name: 'Crimson', color: '#f87171', premium: true },
];

export function findSkin(id: string): Skin {
  return SKIN_CATALOG.find((s) => s.id === id) ?? SKIN_CATALOG[0];
}
